import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import './LoanHistory.css';
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import ProfileHeader from "../Dashboard/ProfilePage/ProfileHeader";
import { loanDetail } from "../../Utils/api";

function LoanDetail() {
  const location = useLocation();
  const { leadId } = location.state || {};
  const [loan, setLoan] = useState(null);
  const [collection, setCollection] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = {
      lead_id: leadId,
    };

    loanDetail(params).then(resp => {
      if (resp?.data?.Status === 1) {
        // setStorage("eligibility",resp?.data?.Data?.registration_successful)
        const loanData = resp?.data?.data[0] || {};
        const collectionData = resp?.data?.collection[0] || {};
        setLoan(loanData);
        setCollection(collectionData);
      }
    });
  }, []);

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error}</div>;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />
      <div className="mt-8">
        {loan ? (
          <>
            <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-6 sm:p-8">

              <h2 className="text-2xl font-bold text-[#173A7A] border-b border-gray-200 pb-4 mb-6">
                Loan Details
              </h2>

              <div className="divide-y divide-gray-200">

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Loan Number</span>
                  <span className="text-[#173A7A]">{loan.loan_no || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Customer Name</span>
                  <span className="text-[#173A7A]">{loan.first_name || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Monthly Salary</span>
                  <span className="text-[#173A7A]">
                    ₹{loan.monthly_salary_amount || "0"}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Loan Amount</span>
                  <span className="text-[#173A7A]">
                    ₹{loan.loan_amount || "0"}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Tenure</span>
                  <span className="text-[#173A7A]">{loan.tenure || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Purpose</span>
                  <span className="text-[#173A7A]">{loan.purpose || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Mobile</span>
                  <span className="text-[#173A7A]">{loan.mobile || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Email</span>
                  <span className="text-[#173A7A] break-all">
                    {loan.email || "NA"}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Application Status</span>
                  <span
                    className={`font-semibold px-3 py-1 rounded-full text-sm w-fit
          ${loan.status?.toLowerCase() === "approved"
                        ? "bg-green-100 text-green-700"
                        : loan.status?.toLowerCase() === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : loan.status?.toLowerCase() === "rejected"
                            ? "bg-red-100 text-red-700"
                            : "bg-blue-100 text-blue-700"
                      }`}
                  >
                    {loan.status || "NA"}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">PAN Card</span>
                  <span className="text-[#173A7A]">{loan.pancard || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Current City</span>
                  <span className="text-[#173A7A]">{loan.m_city_name || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Current State</span>
                  <span className="text-[#173A7A]">{loan.m_state_name || "NA"}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-4">
                  <span className="font-semibold text-[#082654]">Loan Date</span>
                  <span className="text-[#173A7A]">
                    {loan.lead_final_disbursed_date || "NA"}
                  </span>
                </div>

              </div>

            </div>
            {/* <br/>
            <h2>Payment History</h2>
            <div className="collection-container">
              {collection.length > 0 ? (
                collection.map((item, index) => (
                  <div key={index} className="collection-card">
                    <p><strong>Received Amount:</strong> {item.received_amount}</p>
                    <p><strong>Date of Received:</strong> {formatDate(item.date_of_recived)}</p>
                    <p><strong>Remarks:</strong> {item.remarks}</p>
                  </div>
                ))
              ) : (
                <p>No Payment History available.</p>
              )}
            </div> */}
          </>
        ) : (
         <div className="flex  items-center justify-center rounded-2xl border border-dashed border-gray-300 bg-white py-12 px-6 text-center shadow-sm">
 

  <h3 className="text-xl font-semibold text-[#1D3557]">
    No Loan Details Found
  </h3>

  

  
</div>
        )}
      </div>
    </ProfilePreviewWrapper>
  );
}

export default LoanDetail;